/*
 * PEARSON PROPRIETARY AND CONFIDENTIAL INFORMATION SUBJECT TO NDA
 * Copyright © 2018 Pearson Education, Inc.
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains the property of
 * Pearson Education, Inc. The intellectual and technical concepts contained
 * herein are proprietary to Pearson Education, Inc. and may be covered by U.S.
 * and Foreign Patents, patent applications, and are protected by trade secret
 * or copyright law. Dissemination of this information, reproduction of this
 * material, and copying or distribution of this software is strictly forbidden
 * unless prior written permission is obtained from Pearson Education, Inc.
 */

import React, { Component } from 'react';
import { TEXT_TYPES } from "../../../constants/APP_CONSTANTS";
import FileUploadDisplayComponent from '../../widgets/FileUploadDisplay/FileUploadDisplayComponent';
import AxiosClient from '../../../_helpers/http.helper';
import config from "../../../config";
import urlHelper from '../../../_helpers/url.format.helper';
import ModalDialog from "../../widgets/ModalDialog/ModalDialog";
import {Link} from "react-router-dom";

export default class DeleteCCManagement extends Component {

    constructor(props) {
        super(props);
        this.state = {
            file: "",
            formData: "",
            showPopup: false,
            percentage: 0,
            batchId: "",
            showBatchCompletePopup: false,
            batchStatus: "",
            failedMsg: "",
            disableImport: true
        };

        this.showPopup = this.showPopup.bind(this);
        this.handleChange = this.handleChange.bind(this);
    }

    handleChange(e) {
        if (e.target.files.length > 0) {
            this.setState({ batchId: "" });
            this.setState({ failedMsg: "" });
            this.setState({ batchStatus: ""});
            this.setState({ file: e.target.files[0].name });
            const formData = new FormData();
            formData.append('file', e.target.files[0]);
            this.setState({ formData: formData });
            this.setState({ disableImport: false });
        }
    }

    showPopup() {
        this.setState({ showPopup: true });
        this.setState({ failedMsg: "" });
    }

    closePopup() {
        this.setState({ showPopup: false });
    }

    showBatchCompletePopup() {
        this.setState({ showBatchCompletePopup: true });

    }

    closeBatchCompletePopup() {
        this.setState({ percentage: 0 });
        if (this.coverLinkTimeout) {
            clearInterval(this.coverLinkTimeout);
        }
        this.setState({ disableImport: true });
        this.setState({ showBatchCompletePopup: false });
    }

    changeUploadProgress() {
        this.setState({ percentage: 100 });
    }

    axiosRequest() {
        this.closePopup();

        let searchRoute = config.collectionService.routes.deleteUrl;

        const url = urlHelper.formatUrl(
            config.collectionService.baseUrl,
            searchRoute
        );
        this.coverLinkTimeout = setInterval(() => {
            if (this.state.percentage < 90) {
                this.setState({ percentage: this.state.percentage + 5 });
            }
        }, 2000);
        AxiosClient.post(url, this.state.formData, { "headers": { "content-type": "multipart/form-data" } })
            .then(response => {
                this.changeUploadProgress();
                setTimeout(() => this.showBatchCompletePopup(), 500);
                this.setState({ batchId: response.data.batchId });
                this.setState({ batchStatus: TEXT_TYPES.SUCCESS_MSG });
            })
            .catch(error => {
                console.log("Error");
                if(error.response){
                    this.changeUploadProgress();
                    setTimeout(() => this.setState({ percentage: 0 }), 500);
                    if (this.coverLinkTimeout) {
                        clearInterval(this.coverLinkTimeout);
                    }
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG});
                    this.setState({ failedMsg: " (" + error.response.data.message + ")"});
                }
                else{
                    this.setState({ batchStatus: TEXT_TYPES.FAILED_MSG});
                }
                this.setState({ disableImport: true });
                return error;
            });
    }

    render() {
        return (
            <div className="content-home-page">
                <div>
                    <label className="pe-page-title--small">Import Curated Collections to be Deleted</label>
                    <hr />
                    <label>{TEXT_TYPES.CC_DELETION_NOTE}</label>
                </div>
                <div>
                    {this.state.file != ""
                    && <FileUploadDisplayComponent file={this.state.file} percentage={this.state.percentage} showBatchStatus={this.state.batchStatus} failedMsg={this.state.failedMsg}></FileUploadDisplayComponent>
                    }
                    <ModalDialog
                        title={TEXT_TYPES.UPLOAD_FILE_CONFIRMATION}
                        showModal={this.state.showPopup}
                        onCancel={this.closePopup.bind(this)}
                        onSuccess={this.axiosRequest.bind(this)}
                        successText="OK">
                        <div className="modal-body">
                            <p>
                                {TEXT_TYPES.UPLOAD_FILE_CONFIRMATION_MSG}
                            </p>
                        </div>
                    </ModalDialog>
                    <ModalDialog
                        title={TEXT_TYPES.UPLOAD_FILE_COMPLETE_MSG}
                        showCloseControls={false}
                        showModal={this.state.showBatchCompletePopup}
                        showCancel={false}
                        onSuccess={this.closeBatchCompletePopup.bind(this)}
                        successText="OK">
                        <div className="modal-body">
                            <p>
                                <label>{TEXT_TYPES.UPLOAD_BATCH_INFO_MSG} {this.state.batchId}.  <Link to="/cc-deletion-status"><b>{TEXT_TYPES.VIEW_STATUS_MSG}</b></Link></label>
                            </p>
                        </div>
                    </ModalDialog>
                </div>
                <br></br>
                <div className="pe-col-12 fileLoad">
                    <div className="buttons">
                        <input id="fileLoader" type="file" title="Load File" ref={(ref) => this.upload = ref} onClick ={(event)=> { event.target.value = null; }} onChange={this.handleChange}/>
                        <button type="file" name="files" className="pe-btn selectBtn" onClick={()=> this.upload.click()}>Select</button>
                    </div>
                    <div className="buttons">                        
                        <button className="pe-btn pe-btn__primary" disabled={this.state.disableImport} onClick={this.showPopup}>Import</button>
                    </div>
                </div>

            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/pages/CCManagement/DeleteCCManagement.js